import LocationSelector from "./LocationSelectorNoSSR";

export default LocationSelector;
